const { type } = require('constants/Wispet');

const initialState = {
   wispets: {
      create: {
         loading: false,
         error: '',
      },
      onUpdate: {
         loading: false,
         error: '',
      },
      list: {
         loading: false,
         error: '',
         data: [],
         page: 1,
         totalPage: null,
         totalData: 0,
      },
      detail: {
         loading: false,
         error: '',
         data: null,
      },
      detailLeaderboard: {
         loading: false,
         error: '',
         data: null,
      },
      listPoiCategory: {
         loading: false,
         error: '',
         data: [],
         page: 1,
         totalPage: null,
         totalData: 0,
         params: '',
      },
      onCreatePOICategory: {
         loading: false,
         error: '',
      },
      onDelete: {
         loading: false,
         error: '',
      },
      onUpdatePOICategory: {
         loading: false,
         error: '',
      },
      detailPOICategory: {
         loading: false,
         error: '',
         data: null,
      },
      listPOI: {
         loading: false,
         error: '',
         data: [],
         page: 1,
         totalPage: null,
         totalData: 0,
         params: '',
      },
      onCreatePOI: {
         loading: false,
         error: '',
      },
      onDeleteBrand: {
         loading: false,
         error: '',
      },
      onUpdatePOI: {
         loading: false,
         error: '',
      },
      detailPOI: {
         loading: false,
         error: '',
         data: {},
      },
   },
};

const wispetsReducer = (state = initialState.wispets, action) => {
   switch (action.type) {
      case type.CREATE_WISPETS_LOADING:
         return {
            ...state,
            create: {
               ...state.create,
               loading: true,
            },
         };
      case type.CREATE_WISPETS_SUCCESS:
         return {
            ...state,
            create: {
               ...state.create,
               loading: false,
            },
         };
      case type.CREATE_WISPETS_FAILED:
         return {
            ...state,
            create: {
               ...state.create,
               loading: false,
               error: action.message,
            },
         };
      case type.UPDATE_WISPETS_LOADING:
         return {
            ...state,
            onUpdate: {
               ...state.onUpdate,
               loading: true,
            },
         };
      case type.UPDATE_WISPETS_SUCCESS:
         return {
            ...state,
            onUpdate: {
               ...state.onUpdate,
               loading: false,
            },
         };
      case type.UPDATE_WISPETS_FAILED:
         return {
            ...state,
            onUpdate: {
               ...state.onUpdate,
               loading: false,
               error: action.message,
            },
         };
      case type.GET_LIST_WISPETS_LOADING:
         return {
            ...state,
            list: {
               ...state.list,
               loading: true,
            },
         };
      case type.GET_LIST_WISPETS_SUCCESS:
         return {
            ...state,
            list: {
               ...state.list,
               loading: false,
               data: action.data,
               totalPage: parseInt(action.totalPage),
               totalData: parseInt(action.totalData),
               page: action.page || state.list.page,
            },
         };
      case type.GET_LIST_WISPETS_FAILED:
         return {
            ...state,
            list: {
               ...state.list,
               loading: false,
               error: action.message,
            },
         };
      case type.GET_DETAIL_WISPETS_LOADING:
         return {
            ...state,
            detail: {
               ...state.detail,
               loading: true,
            },
         };
      case type.GET_DETAIL_WISPETS_SUCCESS:
         return {
            ...state,
            detail: {
               ...state.detail,
               loading: false,
               data: action.data,
            },
         };
      case type.GET_DETAIL_WISPETS_FAILED:
         return {
            ...state,
            detail: {
               ...state.detail,
               loading: false,
               error: action.message,
            },
         };
      case type.GET_DETAIL_WISPETS_LEADERBOARD_LOADING:
         return {
            ...state,
            detailLeaderboard: {
               ...state.detailLeaderboard,
               loading: true,
            },
         };
      case type.GET_DETAIL_WISPETS_LEADERBOARD_SUCCESS:
         return {
            ...state,
            detailLeaderboard: {
               ...state.detailLeaderboard,
               loading: false,
               data: action.data,
            },
         };
      case type.GET_DETAIL_WISPETS_LEADERBOARD_FAILED:
         return {
            ...state,
            detailLeaderboard: {
               ...state.detailLeaderboard,
               loading: false,
               error: action.message,
            },
         };
      case type.GET_CATEGORY_LOADING:
         return {
            ...state,
            listPoiCategory: {
               ...state.listPoiCategory,
               loading: true,
            },
         };
      case type.GET_CATEGORY_SUCCESS:
         return {
            ...state,
            listPoiCategory: {
               ...state.listPoiCategory,
               loading: false,
               data: action.data,
               totalPage: parseInt(action.totalPage),
               totalData: parseInt(action.totalData),
               page: action.page || state.listPoiCategory.page,
               params: action.params || '',
            },
         };
      case type.GET_CATEGORY_FAILED:
         return {
            ...state,
            listPoiCategory: {
               ...state.listPoiCategory,
               loading: false,
               error: action.message,
            },
         };

      case type.CREATE_POI_CATEGORY_LOADING:
         return {
            ...state,
            onCreatePOICategory: {
               ...state.onCreatePOICategory,
               loading: true,
            },
         };
      case type.CREATE_POI_CATEGORY_SUCCESS:
         return {
            ...state,
            onCreatePOICategory: {
               ...state.onCreatePOICategory,
               loading: false,
            },
         };
      case type.CREATE_POI_CATEGORY_FAILED:
         return {
            ...state,
            onCreatePOICategory: {
               ...state.onCreatePOICategory,
               loading: false,
               error: action.message,
            },
         };
      case type.DELETE_POI_CATEGORY_LOADING:
         return {
            ...state,
            onDelete: {
               ...state.onDelete,
               loading: true,
            },
         };
      case type.DELETE_POI_CATEGORY_SUCCESS:
         return {
            ...state,
            onDelete: {
               ...state.onDelete,
               loading: false,
            },
         };
      case type.DELETE_POI_CATEGORY_FAILED:
         return {
            ...state,
            onDelete: {
               ...state.onDelete,
               loading: false,
               error: action.message,
            },
         };

      case type.SHOW_POI_CATEGORY_LOADING:
         return {
            ...state,
            detailPOICategory: {
               ...state.detailPOICategory,
               loading: true,
            },
         };
      case type.SHOW_POI_CATEGORY_SUCCESS:
         return {
            ...state,
            detailPOICategory: {
               ...state.detailPOICategory,
               data: action.data,
               loading: false,
            },
         };
      case type.SHOW_POI_CATEGORY_FAILED:
         return {
            ...state,
            detailPOICategory: {
               ...state.detailPOICategory,
               loading: false,
               error: action.message,
            },
         };

      case type.UPDATE_POI_CATEGORY_LOADING:
         return {
            ...state,
            onUpdatePOICategory: {
               ...state.onUpdatePOICategory,
               loading: true,
            },
         };
      case type.UPDATE_POI_CATEGORY_SUCCESS:
         return {
            ...state,
            onUpdatePOICategory: {
               ...state.onUpdatePOICategory,
               loading: false,
            },
         };
      case type.UPDATE_POI_CATEGORY_FAILED:
         return {
            ...state,
            onUpdatePOICategory: {
               ...state.onUpdatePOICategory,
               loading: false,
               error: action.message,
            },
         };
      case type.GET_POI_LOADING:
         return {
            ...state,
            listPOI: {
               ...state.listPOI,
               loading: true,
            },
         };
      case type.GET_POI_SUCCESS:
         return {
            ...state,
            listPOI: {
               ...state.listPOI,
               loading: false,
               data: action.data,
               totalPage: parseInt(action.totalPage),
               totalData: parseInt(action.totalData),
               page: action.page || state.listPOI.page,
               params: action.params || '',
            },
         };
      case type.GET_POI_FAILED:
         return {
            ...state,
            listPOI: {
               ...state.listPOI,
               loading: false,
               error: action.message,
            },
         };

      case type.CREATE_POI_LOADING:
         return {
            ...state,
            onCreatePOI: {
               ...state.onCreatePOI,
               loading: true,
            },
         };
      case type.CREATE_POI_SUCCESS:
         return {
            ...state,
            onCreatePOI: {
               ...state.onCreatePOI,
               loading: false,
            },
         };
      case type.CREATE_POI_FAILED:
         return {
            ...state,
            onCreatePOI: {
               ...state.onCreatePOI,
               loading: false,
               error: action.message,
            },
         };
      case type.DELETE_POI_LOADING:
         return {
            ...state,
            onDeleteBrand: {
               ...state.onDeleteBrand,
               loading: true,
            },
         };
      case type.DELETE_POI_SUCCESS:
         return {
            ...state,
            onDeleteBrand: {
               ...state.onDeleteBrand,
               loading: false,
            },
         };
      case type.DELETE_POI_FAILED:
         return {
            ...state,
            onDeleteBrand: {
               ...state.onDeleteBrand,
               loading: false,
               error: action.message,
            },
         };

      case type.SHOW_BRAND_LOADING:
         return {
            ...state,
            detailPOI: {
               ...state.detailPOI,
               loading: true,
            },
         };
      case type.SHOW_BRAND_SUCCESS:
         return {
            ...state,
            detailPOI: {
               ...state.detailPOI,
               data: action.data,
               loading: false,
            },
         };
      case type.SHOW_BRAND_FAILED:
         return {
            ...state,
            detailPOI: {
               ...state.detailPOI,
               loading: false,
               error: action.message,
            },
         };

      case type.UPDATE_POI_LOADING:
         return {
            ...state,
            onUpdatePOI: {
               ...state.onUpdatePOI,
               loading: true,
            },
         };
      case type.UPDATE_POI_SUCCESS:
         return {
            ...state,
            onUpdatePOI: {
               ...state.onUpdatePOI,
               loading: false,
            },
         };
      case type.UPDATE_POI_FAILED:
         return {
            ...state,
            onUpdatePOI: {
               ...state.onUpdatePOI,
               loading: false,
               error: action.message,
            },
         };
      default:
         return state;
   }
};
export default wispetsReducer;
